import {useState} from 'react'
import {useAuthContext} from './useAuthContext'

export const useSignup = () => {
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(null)
    const {dispatch} = useAuthContext()

    const signup = async (firstName, lastName, email, password, confirmPassword) => {
        setIsLoading(true)
        setError(null)

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/signup`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({firstName, lastName, email, password, confirmPassword}),
            credentials: 'include'
        })
        const json = await response.json()

        if (!response.ok) { //if response is error code, eg 400 then response.ok will be false
            setIsLoading(false)
            setError(json.error)
            return
        }
        //update the auth context
        dispatch({type: 'LOGIN', payload: json.userData})
        setIsLoading(false)
    }

    return ({signup, isLoading, error})
}